import React, { useContext, useState } from "react";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import { DesktopGrid } from "~/assets/js/components/Layout/DesktopGrid";
import { CheckoutContext, ACTIONS, PAGES } from "../../CheckoutProvider";
import { LoginUser, resetPassword } from "~/assets/js/Api/userApi";
import { AddToast } from "~/assets/js/components/Toast";
import { wait } from "~/assets/js/Helpers/util";
import i18next from "i18next";
import {
    ForgotPasswordForm,
    LoginForm,
} from "~/assets/js/components/Forms/modules";
import NewCustomer from "./NewCustomer";

const Login = () => {
    const { dispatch } = useContext(CheckoutContext);
    const [forgotPass, setForgotPassView] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const { isDesktop } = useViewport();

    const handlePasswordReset = async ({ email }) => {
        setLoading(true);
        const response = await resetPassword(email);
        setLoading(false);

        if (!response.ok) {
            return dispatch(
                AddToast("danger", i18next.t("toasts.passwordReset.error"))
            );
        }

        dispatch(
            AddToast("success", i18next.t("toasts.passwordReset.success"))
        );
        return setForgotPassView(false);
    };

    const handleLogin = async ({ email, password, staySigned }) => {
        setLoading(true);
        const response = await LoginUser(email, password, staySigned);
        setLoading(false);
        if (!response.ok) {
            return dispatch(
                AddToast("danger", i18next.t("toasts.login.error"))
            );
        }

        return await setUser(response.user);
    };

    const setUser = async (user) => {
        dispatch({ type: ACTIONS.LOGIN, payload: user });
        dispatch(
            AddToast(
                "success",
                i18next.t("toasts.login.success", {
                    name: user.displayName,
                })
            )
        );
        await wait(1000);
        dispatch({ type: ACTIONS.CHANGE_PAGE, payload: PAGES.CONTACT_DETAILS });
    };

    return (
        <>
            <DesktopGrid
                leftSide={
                    forgotPass ? (
                        <ForgotPasswordForm
                            changeView={() => setForgotPassView(false)}
                            isLoading={isLoading}
                            onSubmit={handlePasswordReset}
                        />
                    ) : (
                        <LoginForm
                            changeView={() => setForgotPassView(true)}
                            isLoading={isLoading}
                            onSubmit={handleLogin}
                        />
                    )
                }
                rightSide={
                    <>
                        {!isDesktop && <hr className="section-divider" />}
                        <NewCustomer />
                    </>
                }
            />
        </>
    );
};

export default Login;
